/* eslint-disable import/first */
import React, { useState, useEffect, useContext } from 'react';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector, useDispatch } = Redux;
import { useNavigate, useLocation } from '@reach/router';
import css from './index.module.scss';
import NotLogged from '../../components/NotLogged';
const { deleteSavedCard, fetchSavedCards } = Slices.homeSlice;
import { Context } from '../../components/Multi-lang/Wrapper';
const { selectCountryValidations } = Slices.configSlice;
const { selectAllMain } = Slices.categorySlice;
const { selectCurrentCountry } = Slices.profileSlice;
const { selectDesktop } = Slices.appSlice;

import CardItem from './CardItem';
import { Avatar, Button } from '@material-ui/core';
import addCardIcon from './images/emptyStateCard.svg';
import { FormattedMessage, useIntl } from 'react-intl';

export const URLEncode = (inputSrc) => encodeURI(inputSrc?.toLowerCase().replace(/\s/g, '-'));

const SavedCards = () => {
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const [showLogin, setShowLogin] = useState(false);
  const [cards, setCards] = useState([]);
  const [fetchData, setfetchData] = useState(true);
  const country = useSelector(selectCurrentCountry);
  const countryValidations = useSelector((state) => selectCountryValidations(state, country));
  const intl = useIntl();

  const [exploreLink, setExploreLink] = useState(null);

  const categories = useSelector(selectAllMain);
  const context = useContext(Context);
  const navigate = useNavigate();
  const location = useLocation();
  const isDesktop = useSelector(selectDesktop);

  const result = categories?.sort((a, b) => a.position - b.position);
  const exploreMenuPath = `/${context?.locale}/${URLEncode(result[0]?.name)}/${result[0]?.id}`;

  useEffect(() => {
    if (auth.guestLogin) {
      setShowLogin(true);
    }
  }, [auth.guestLogin]);

  useEffect(() => {
    if (fetchData) {
      dispatch(fetchSavedCards())
        .then((res) => {
          setCards(res?.payload?.data?.data?.userCards);
        })
        .catch((err) => console.log('Saved Cards Error', err));
      setfetchData(false);
    }
  }, [dispatch, fetchData]);

  useEffect(() => {
    const result = categories.length > 0 && categories?.sort((a, b) => a.position - b.position);
    const exploreMenuPath = `/${context?.locale}/${URLEncode(result?.[0]?.name)}/${
      result?.[0]?.id
    }`;
    setExploreLink(exploreMenuPath);
  }, [categories, context.locale, exploreLink]);

  const removeSavedCard = (token) => {
    const payload = { token };
    dispatch(deleteSavedCard(payload))
      .then((res) => {
        if (localStorage.getItem('_MPS') === token) {
          localStorage.removeItem('_MPS');
          localStorage.removeItem('_PMI');
          localStorage.removeItem('_SubP');
          if (isDesktop && location?.state?.oldLocation?.pathname?.includes('/checkout')) {
            navigate(`/${intl.locale}/cart`);
          }
        }
      })
      .catch((err) => console.log('Delete Card Error', err));
    setfetchData(true);
  };

  return (
    <main className={css.cardsMain}>
      {!showLogin ? (
        <div className={css.section}>
          <div className={css.cardsSection}>
            {cards?.map((item) => {
              return (
                <>
                  <CardItem
                    fetchData={setfetchData}
                    itemData={item}
                    onDelete={() => removeSavedCard(item.token)}
                    lightningPay={countryValidations.lightningPayConfig?.lightningPay}
                  />
                </>
              );
            })}
          </div>
          <div className={css.addCardSection}>
            <div className={css.addCard}>
              {/* <Avatar variante="square" alt={'Add Card'} src={addCardIcon} className={css.image} /> */}
              <img src={addCardIcon} alt="card empty image" />
              <h3 className={css.addCardHeader}>
                <FormattedMessage id="add_new_card" defaultMessage="Add New Card" />
              </h3>
              <p className={css.addCardText}>
                <FormattedMessage
                  id="my_saved_cards_subhead"
                  defaultMessage="Just place a new order with a new card and we would save it for you."
                />
              </p>
              <Button className={css.button} onClick={() => navigate(exploreMenuPath)}>
                <FormattedMessage id="explore_menu" defaultMessage="Explore Menu" />
              </Button>
            </div>
          </div>
        </div>
      ) : (
        <div className={css.log}>
          <NotLogged
            topbar={false}
            heading={<FormattedMessage id="no_saved_cards" defaultMessage="No Saved Cards" />}
            subHeading={
              <FormattedMessage
                id="login_saved_cards"
                defaultMessage="Login to view your Saved Cards"
              />
            }
          />
        </div>
      )}
    </main>
  );
};

export default SavedCards;
